import React from 'react'
import ReactDOM from 'react-dom'
import App from './app/App'
import './tailwind.css'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'

ReactDOM.render(<App />, document.getElementById('root'))

serviceWorkerRegistration.unregister()
